import { render, staticRenderFns } from "./BaseFilterDropdown.vue?vue&type=template&id=dba63f04"
import script from "./BaseFilterDropdown.vue?vue&type=script&lang=js"
export * from "./BaseFilterDropdown.vue?vue&type=script&lang=js"
import style0 from "./BaseFilterDropdown.vue?vue&type=style&index=0&id=dba63f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports